<div class="page">

  <div class="pagehead">
    <div>
      <h1>Buy a device</h1>
      <p>Pick a device for your counter — the amount is deducted from your wallet</p>
    </div>
  </div>

  <div class="devices" *ngIf="getDevice && getDevice.length; else noDevices">
    <div class="card card--hover device" *ngFor="let device of getDevice"
      [class.is-picked]="selectedDevice === device.id"
      (click)="selectedDevice = device.id" role="radio" [attr.aria-checked]="selectedDevice === device.id" tabindex="0"
      (keydown.enter)="selectedDevice = device.id">
      <span class="device-img"><img [src]="device.imageURL" [alt]="device.productName"></span>
      <span class="device-body">
        <span class="device-name">{{ device.productName }}</span>
        <span class="device-price">{{ device.productPrice | erInr }}</span>
      </span>
      <span class="device-check" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>
      </span>
    </div>
  </div>
  <ng-template #noDevices>
    <div class="card page-empty">
      <span class="t">No devices available right now</span>
      Check back later — devices appear here when they're in stock.
    </div>
  </ng-template>

  <div class="buy-actions" *ngIf="getDevice && getDevice.length">
    <button type="button" class="er-btn er-btn--primary" (click)="submit()">Proceed to buy</button>
  </div>

</div>
